import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LANGUAGES, FALLBACK_LANGUAGE, LANGUAGE_STORAGE_KEY } from './types';

// Import English translations
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enShorts from './locales/en/shorts.json';
import enLive from './locales/en/live.json';
import enNews from './locales/en/news.json';
import enAura from './locales/en/aura.json';
import enSettings from './locales/en/settings.json';
import enProfile from './locales/en/profile.json';
import enStudio from './locales/en/studio.json';
import enAuth from './locales/en/auth.json';
import enLegal from './locales/en/legal.json';

// Import Swedish translations
import svCommon from './locales/sv/common.json';
import svHome from './locales/sv/home.json';
import svShorts from './locales/sv/shorts.json';
import svLive from './locales/sv/live.json';
import svNews from './locales/sv/news.json';
import svAura from './locales/sv/aura.json';
import svSettings from './locales/sv/settings.json';
import svProfile from './locales/sv/profile.json';
import svStudio from './locales/sv/studio.json';
import svAuth from './locales/sv/auth.json';
import svLegal from './locales/sv/legal.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frHome from './locales/fr/home.json';
import frShorts from './locales/fr/shorts.json';
import frLive from './locales/fr/live.json';
import frNews from './locales/fr/news.json';
import frAura from './locales/fr/aura.json';
import frSettings from './locales/fr/settings.json';
import frProfile from './locales/fr/profile.json';
import frStudio from './locales/fr/studio.json';
import frAuth from './locales/fr/auth.json';
import frLegal from './locales/fr/legal.json';

// Import German translations
import deCommon from './locales/de/common.json';
import deHome from './locales/de/home.json';
import deShorts from './locales/de/shorts.json';
import deLive from './locales/de/live.json';
import deNews from './locales/de/news.json';
import deAura from './locales/de/aura.json';
import deSettings from './locales/de/settings.json';
import deProfile from './locales/de/profile.json';
import deStudio from './locales/de/studio.json';
import deAuth from './locales/de/auth.json';
import deLegal from './locales/de/legal.json';

// Import Dutch translations
import nlCommon from './locales/nl/common.json';
import nlHome from './locales/nl/home.json';
import nlShorts from './locales/nl/shorts.json';
import nlLive from './locales/nl/live.json';
import nlNews from './locales/nl/news.json';
import nlAura from './locales/nl/aura.json';
import nlSettings from './locales/nl/settings.json';
import nlProfile from './locales/nl/profile.json';
import nlStudio from './locales/nl/studio.json';
import nlAuth from './locales/nl/auth.json';
import nlLegal from './locales/nl/legal.json';

// Import Norwegian translations
import noCommon from './locales/no/common.json';
import noHome from './locales/no/home.json';
import noShorts from './locales/no/shorts.json';
import noLive from './locales/no/live.json';
import noNews from './locales/no/news.json';
import noAura from './locales/no/aura.json';
import noSettings from './locales/no/settings.json';
import noProfile from './locales/no/profile.json';
import noStudio from './locales/no/studio.json';
import noAuth from './locales/no/auth.json';
import noLegal from './locales/no/legal.json';

// Import Danish translations
import daCommon from './locales/da/common.json';
import daHome from './locales/da/home.json';
import daShorts from './locales/da/shorts.json';
import daLive from './locales/da/live.json';
import daNews from './locales/da/news.json';
import daAura from './locales/da/aura.json';
import daSettings from './locales/da/settings.json';
import daProfile from './locales/da/profile.json';
import daStudio from './locales/da/studio.json';
import daAuth from './locales/da/auth.json';
import daLegal from './locales/da/legal.json';

// Import Spanish translations
import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esShorts from './locales/es/shorts.json';
import esLive from './locales/es/live.json';
import esNews from './locales/es/news.json';
import esAura from './locales/es/aura.json';
import esSettings from './locales/es/settings.json';
import esProfile from './locales/es/profile.json';
import esStudio from './locales/es/studio.json';
import esAuth from './locales/es/auth.json';
import esLegal from './locales/es/legal.json';

// Import Portuguese translations
import ptCommon from './locales/pt/common.json';
import ptHome from './locales/pt/home.json';
import ptShorts from './locales/pt/shorts.json';
import ptLive from './locales/pt/live.json';
import ptNews from './locales/pt/news.json';
import ptAura from './locales/pt/aura.json';
import ptSettings from './locales/pt/settings.json';
import ptProfile from './locales/pt/profile.json';
import ptStudio from './locales/pt/studio.json';
import ptAuth from './locales/pt/auth.json';
import ptLegal from './locales/pt/legal.json';

// Import Italian translations
import itCommon from './locales/it/common.json';
import itHome from './locales/it/home.json';
import itShorts from './locales/it/shorts.json';
import itLive from './locales/it/live.json';
import itNews from './locales/it/news.json';
import itAura from './locales/it/aura.json';
import itSettings from './locales/it/settings.json';
import itProfile from './locales/it/profile.json';
import itStudio from './locales/it/studio.json';
import itAuth from './locales/it/auth.json';
import itLegal from './locales/it/legal.json';

// Import Romanian translations
import roCommon from './locales/ro/common.json';
import roHome from './locales/ro/home.json';
import roShorts from './locales/ro/shorts.json';
import roLive from './locales/ro/live.json';
import roNews from './locales/ro/news.json';
import roAura from './locales/ro/aura.json';
import roSettings from './locales/ro/settings.json';
import roProfile from './locales/ro/profile.json';
import roStudio from './locales/ro/studio.json';
import roAuth from './locales/ro/auth.json';
import roLegal from './locales/ro/legal.json';

// Import Russian translations
import ruCommon from './locales/ru/common.json';
import ruHome from './locales/ru/home.json';
import ruShorts from './locales/ru/shorts.json';
import ruLive from './locales/ru/live.json';
import ruNews from './locales/ru/news.json';
import ruAura from './locales/ru/aura.json';
import ruSettings from './locales/ru/settings.json';
import ruProfile from './locales/ru/profile.json';
import ruStudio from './locales/ru/studio.json';
import ruAuth from './locales/ru/auth.json';
import ruLegal from './locales/ru/legal.json';

// Import Polish translations
import plCommon from './locales/pl/common.json';
import plHome from './locales/pl/home.json';
import plShorts from './locales/pl/shorts.json';
import plLive from './locales/pl/live.json';
import plNews from './locales/pl/news.json';
import plAura from './locales/pl/aura.json';
import plSettings from './locales/pl/settings.json';
import plProfile from './locales/pl/profile.json';
import plStudio from './locales/pl/studio.json';
import plAuth from './locales/pl/auth.json';
import plLegal from './locales/pl/legal.json';

// Import Czech translations
import csCommon from './locales/cs/common.json';
import csHome from './locales/cs/home.json';
import csShorts from './locales/cs/shorts.json';
import csLive from './locales/cs/live.json';
import csNews from './locales/cs/news.json';
import csAura from './locales/cs/aura.json';
import csSettings from './locales/cs/settings.json';
import csProfile from './locales/cs/profile.json';
import csStudio from './locales/cs/studio.json';
import csAuth from './locales/cs/auth.json';
import csLegal from './locales/cs/legal.json';

// Import Ukrainian translations
import ukCommon from './locales/uk/common.json';
import ukHome from './locales/uk/home.json';
import ukShorts from './locales/uk/shorts.json';
import ukLive from './locales/uk/live.json';
import ukNews from './locales/uk/news.json';
import ukAura from './locales/uk/aura.json';
import ukSettings from './locales/uk/settings.json';
import ukProfile from './locales/uk/profile.json';
import ukStudio from './locales/uk/studio.json';
import ukAuth from './locales/uk/auth.json';
import ukLegal from './locales/uk/legal.json';

// Import Chinese Simplified translations
import zhCNCommon from './locales/zh-CN/common.json';
import zhCNHome from './locales/zh-CN/home.json';
import zhCNShorts from './locales/zh-CN/shorts.json';
import zhCNLive from './locales/zh-CN/live.json';
import zhCNNews from './locales/zh-CN/news.json';
import zhCNAura from './locales/zh-CN/aura.json';
import zhCNSettings from './locales/zh-CN/settings.json';
import zhCNProfile from './locales/zh-CN/profile.json';
import zhCNStudio from './locales/zh-CN/studio.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import zhCNLegal from './locales/zh-CN/legal.json';

// Import Chinese Traditional translations
import zhTWCommon from './locales/zh-TW/common.json';
import zhTWHome from './locales/zh-TW/home.json';
import zhTWShorts from './locales/zh-TW/shorts.json';
import zhTWLive from './locales/zh-TW/live.json';
import zhTWNews from './locales/zh-TW/news.json';
import zhTWAura from './locales/zh-TW/aura.json';
import zhTWSettings from './locales/zh-TW/settings.json';
import zhTWProfile from './locales/zh-TW/profile.json';
import zhTWStudio from './locales/zh-TW/studio.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWLegal from './locales/zh-TW/legal.json';

// Import Japanese translations
import jaCommon from './locales/ja/common.json';
import jaHome from './locales/ja/home.json';
import jaShorts from './locales/ja/shorts.json';
import jaLive from './locales/ja/live.json';
import jaNews from './locales/ja/news.json';
import jaAura from './locales/ja/aura.json';
import jaSettings from './locales/ja/settings.json';
import jaProfile from './locales/ja/profile.json';
import jaStudio from './locales/ja/studio.json';
import jaAuth from './locales/ja/auth.json';
import jaLegal from './locales/ja/legal.json';

// Import Korean translations
import koCommon from './locales/ko/common.json';
import koHome from './locales/ko/home.json';
import koShorts from './locales/ko/shorts.json';
import koLive from './locales/ko/live.json';
import koNews from './locales/ko/news.json';
import koAura from './locales/ko/aura.json';
import koSettings from './locales/ko/settings.json';
import koProfile from './locales/ko/profile.json';
import koStudio from './locales/ko/studio.json';
import koAuth from './locales/ko/auth.json';
import koLegal from './locales/ko/legal.json';

// Import Vietnamese translations
import viCommon from './locales/vi/common.json';
import viHome from './locales/vi/home.json';
import viShorts from './locales/vi/shorts.json';
import viLive from './locales/vi/live.json';
import viNews from './locales/vi/news.json';
import viAura from './locales/vi/aura.json';
import viSettings from './locales/vi/settings.json';
import viProfile from './locales/vi/profile.json';
import viStudio from './locales/vi/studio.json';
import viAuth from './locales/vi/auth.json';
import viLegal from './locales/vi/legal.json';

// Import Thai translations
import thCommon from './locales/th/common.json';
import thHome from './locales/th/home.json';
import thShorts from './locales/th/shorts.json';
import thLive from './locales/th/live.json';
import thNews from './locales/th/news.json';
import thAura from './locales/th/aura.json';
import thSettings from './locales/th/settings.json';
import thProfile from './locales/th/profile.json';
import thStudio from './locales/th/studio.json';
import thAuth from './locales/th/auth.json';
import thLegal from './locales/th/legal.json';

// Import Indonesian translations
import idCommon from './locales/id/common.json';
import idHome from './locales/id/home.json';
import idShorts from './locales/id/shorts.json';
import idLive from './locales/id/live.json';
import idNews from './locales/id/news.json';
import idAura from './locales/id/aura.json';
import idSettings from './locales/id/settings.json';
import idProfile from './locales/id/profile.json';
import idStudio from './locales/id/studio.json';
import idAuth from './locales/id/auth.json';
import idLegal from './locales/id/legal.json';

// Import Hindi translations
import hiCommon from './locales/hi/common.json';
import hiHome from './locales/hi/home.json';
import hiShorts from './locales/hi/shorts.json';
import hiLive from './locales/hi/live.json';
import hiNews from './locales/hi/news.json';
import hiAura from './locales/hi/aura.json';
import hiSettings from './locales/hi/settings.json';
import hiProfile from './locales/hi/profile.json';
import hiStudio from './locales/hi/studio.json';
import hiAuth from './locales/hi/auth.json';
import hiLegal from './locales/hi/legal.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        shorts: enShorts,
        live: enLive,
        news: enNews,
        aura: enAura,
        settings: enSettings,
        profile: enProfile,
        studio: enStudio,
        auth: enAuth,
        legal: enLegal,
      },
      sv: {
        common: svCommon,
        home: svHome,
        shorts: svShorts,
        live: svLive,
        news: svNews,
        aura: svAura,
        settings: svSettings,
        profile: svProfile,
        studio: svStudio,
        auth: svAuth,
        legal: svLegal,
      },
      fr: {
        common: frCommon,
        home: frHome,
        shorts: frShorts,
        live: frLive,
        news: frNews,
        aura: frAura,
        settings: frSettings,
        profile: frProfile,
        studio: frStudio,
        auth: frAuth,
        legal: frLegal,
      },
      de: {
        common: deCommon,
        home: deHome,
        shorts: deShorts,
        live: deLive,
        news: deNews,
        aura: deAura,
        settings: deSettings,
        profile: deProfile,
        studio: deStudio,
        auth: deAuth,
        legal: deLegal,
      },
      nl: {
        common: nlCommon,
        home: nlHome,
        shorts: nlShorts,
        live: nlLive,
        news: nlNews,
        aura: nlAura,
        settings: nlSettings,
        profile: nlProfile,
        studio: nlStudio,
        auth: nlAuth,
        legal: nlLegal,
      },
      no: {
        common: noCommon,
        home: noHome,
        shorts: noShorts,
        live: noLive,
        news: noNews,
        aura: noAura,
        settings: noSettings,
        profile: noProfile,
        studio: noStudio,
        auth: noAuth,
        legal: noLegal,
      },
      da: {
        common: daCommon,
        home: daHome,
        shorts: daShorts,
        live: daLive,
        news: daNews,
        aura: daAura,
        settings: daSettings,
        profile: daProfile,
        studio: daStudio,
        auth: daAuth,
        legal: daLegal,
      },
      es: {
        common: esCommon,
        home: esHome,
        shorts: esShorts,
        live: esLive,
        news: esNews,
        aura: esAura,
        settings: esSettings,
        profile: esProfile,
        studio: esStudio,
        auth: esAuth,
        legal: esLegal,
      },
      pt: {
        common: ptCommon,
        home: ptHome,
        shorts: ptShorts,
        live: ptLive,
        news: ptNews,
        aura: ptAura,
        settings: ptSettings,
        profile: ptProfile,
        studio: ptStudio,
        auth: ptAuth,
        legal: ptLegal,
      },
      it: {
        common: itCommon,
        home: itHome,
        shorts: itShorts,
        live: itLive,
        news: itNews,
        aura: itAura,
        settings: itSettings,
        profile: itProfile,
        studio: itStudio,
        auth: itAuth,
        legal: itLegal,
      },
      ro: {
        common: roCommon,
        home: roHome,
        shorts: roShorts,
        live: roLive,
        news: roNews,
        aura: roAura,
        settings: roSettings,
        profile: roProfile,
        studio: roStudio,
        auth: roAuth,
        legal: roLegal,
      },
      ru: {
        common: ruCommon,
        home: ruHome,
        shorts: ruShorts,
        live: ruLive,
        news: ruNews,
        aura: ruAura,
        settings: ruSettings,
        profile: ruProfile,
        studio: ruStudio,
        auth: ruAuth,
        legal: ruLegal,
      },
      pl: {
        common: plCommon,
        home: plHome,
        shorts: plShorts,
        live: plLive,
        news: plNews,
        aura: plAura,
        settings: plSettings,
        profile: plProfile,
        studio: plStudio,
        auth: plAuth,
        legal: plLegal,
      },
      cs: {
        common: csCommon,
        home: csHome,
        shorts: csShorts,
        live: csLive,
        news: csNews,
        aura: csAura,
        settings: csSettings,
        profile: csProfile,
        studio: csStudio,
        auth: csAuth,
        legal: csLegal,
      },
      uk: {
        common: ukCommon,
        home: ukHome,
        shorts: ukShorts,
        live: ukLive,
        news: ukNews,
        aura: ukAura,
        settings: ukSettings,
        profile: ukProfile,
        studio: ukStudio,
        auth: ukAuth,
        legal: ukLegal,
      },
      'zh-CN': {
        common: zhCNCommon,
        home: zhCNHome,
        shorts: zhCNShorts,
        live: zhCNLive,
        news: zhCNNews,
        aura: zhCNAura,
        settings: zhCNSettings,
        profile: zhCNProfile,
        studio: zhCNStudio,
        auth: zhCNAuth,
        legal: zhCNLegal,
      },
      'zh-TW': {
        common: zhTWCommon,
        home: zhTWHome,
        shorts: zhTWShorts,
        live: zhTWLive,
        news: zhTWNews,
        aura: zhTWAura,
        settings: zhTWSettings,
        profile: zhTWProfile,
        studio: zhTWStudio,
        auth: zhTWAuth,
        legal: zhTWLegal,
      },
      ja: {
        common: jaCommon,
        home: jaHome,
        shorts: jaShorts,
        live: jaLive,
        news: jaNews,
        aura: jaAura,
        settings: jaSettings,
        profile: jaProfile,
        studio: jaStudio,
        auth: jaAuth,
        legal: jaLegal,
      },
      ko: {
        common: koCommon,
        home: koHome,
        shorts: koShorts,
        live: koLive,
        news: koNews,
        aura: koAura,
        settings: koSettings,
        profile: koProfile,
        studio: koStudio,
        auth: koAuth,
        legal: koLegal,
      },
      vi: {
        common: viCommon,
        home: viHome,
        shorts: viShorts,
        live: viLive,
        news: viNews,
        aura: viAura,
        settings: viSettings,
        profile: viProfile,
        studio: viStudio,
        auth: viAuth,
        legal: viLegal,
      },
      th: {
        common: thCommon,
        home: thHome,
        shorts: thShorts,
        live: thLive,
        news: thNews,
        aura: thAura,
        settings: thSettings,
        profile: thProfile,
        studio: thStudio,
        auth: thAuth,
        legal: thLegal,
      },
      id: {
        common: idCommon,
        home: idHome,
        shorts: idShorts,
        live: idLive,
        news: idNews,
        aura: idAura,
        settings: idSettings,
        profile: idProfile,
        studio: idStudio,
        auth: idAuth,
        legal: idLegal,
      },
      hi: {
        common: hiCommon,
        home: hiHome,
        shorts: hiShorts,
        live: hiLive,
        news: hiNews,
        aura: hiAura,
        settings: hiSettings,
        profile: hiProfile,
        studio: hiStudio,
        auth: hiAuth,
        legal: hiLegal,
      },
    },
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'home', 'shorts', 'live', 'news', 'aura', 'settings', 'profile', 'studio', 'auth', 'legal'],
    defaultNS: 'common',
  });

export default i18n;
